import { AUTH_PATH, FETCH_GET_DEFAULT, PAIRS_PATH } from '@constants'
import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'

const isBrowser = typeof window !== 'undefined'

const getAuthPairs = async (token: string) => {
  const url = `${window.location.origin}${PAIRS_PATH}`
  try {
    const response = await fetch(url, {
      ...FETCH_GET_DEFAULT,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'include',
    })
    return response
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
  }
}

const checkResponseStatusAndRefreshToken = async (status: number) => {
  if (status === 200) {
    return true
  }
  if (status !== 401) {
    return false
  }
  return await refreshToken()
}

const refreshToken = async () => {
  const data = { refreshToken: Cookies.get('app_refresh_token'), grantType: 'refresh_token' }
  const url = `${window.location.origin}${AUTH_PATH}`

  if (!data.refreshToken) {
    return false
  }
  try {
    const response: any = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify(data),
      credentials: 'include',
    })

    if (response.status !== 200) {
      Cookies.remove('app_access_token')
      Cookies.remove('app_refresh_token')
      Cookies.remove('app_user_email')
      return false
    }

    Cookies.set('app_access_token', response.data.access_token)
    Cookies.set('app_refresh_token', response.data.refresh_token)
    return true
  } catch (e) {
    return false
  }
}

const useCheckAuth = () => {
  const token = Boolean(Cookies.get('app_access_token')) || null
  const [withAuth, setWithAuth] = useState<null | boolean>(token)

  useEffect(() => {
    if (!isBrowser) {
      return
    }
    const token = Cookies.get('app_access_token')

    if (!token) {
      setWithAuth(false)
      return
    }

    getAuthPairs(token)
      .then(async (r: any) => await checkResponseStatusAndRefreshToken(r.status))
      .then(auth => setWithAuth(auth))
  }, [])

  return withAuth
}

export default useCheckAuth
